import React, { useEffect, useState } from 'react';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { graphql, withApollo } from 'react-apollo';
import compose from 'lodash/flowRight';
import CURRENT_USER from '../../../../GraphQl/Queries/CURRENT_USER';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';

import GET_ROLL_UP_PAID_SEARCH from '../../../../GraphQl/Queries/GET_ROLL_UP_PAID_SEARCH';
import RollUpPaidSearchController from './RollUpPaidSearchController';
import moment from 'moment';
import { advertiserIdParamKey } from '../../../../../platform/shared/AdvertiserFilter/AdvertiserFilter.container';

const RollUpPaidSearchDataLoader = ({ children, ...props }) => {
  const loggedInRole = props.currentUser.role;
  let params = new URLSearchParams(props.location.search);
  const org = params.get(`${advertiserIdParamKey}`);
  const orgId = loggedInRole.org.id;
  const { startDate, endDate, setLoadProgress, loadProgress, totals, setTotals, productOn } = props;

  const [advertiserIds, setAdvertiserIds] = useState([orgId]);

  useEffect(() => {
    if (!org) {
      return setAdvertiserIds([orgId]);
    }
    setAdvertiserIds(org.split('+'));
  }, [org, orgId]);

  const { loading, data, refetch } = useQuery(GET_ROLL_UP_PAID_SEARCH, {
    variables: {
      orgId,
      startDate: startDate ? moment(startDate).startOf('day').utc() : undefined,
      endDate: endDate ? moment(endDate).endOf('day').utc() : undefined,
      advertiserIds: !isEmpty(advertiserIds) ? advertiserIds : undefined,
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      setLoadProgress(loadProgress - 1);
      if (data && data.getRollUpPaidSearch) {
        let totalImpressions = (totals.impressions || 0) + data.getRollUpPaidSearch.impressions;
        let spend = (totals.spend || 0) + data.getRollUpPaidSearch.cost;
        let revenue = (totals.revenue || 0) + data.getRollUpPaidSearch.revenue;
        setTotals({
          ...totals,
          impressions: totalImpressions,
          spend: spend,
          revenue: revenue,
          roas: (revenue / spend) * 100,
        });
      }
    },
    fetchPolicy: 'network-only',
  });

  const [
    getPrevRangeData,
    { loading: loadingPrevRangeData, data: prevRangeData, refetch: refetchPrevRangeData },
  ] = useLazyQuery(GET_ROLL_UP_PAID_SEARCH);

  useEffect(() => {
    if (startDate && endDate) {
      const diff = endDate.diff(startDate, 'days');
      const prevStart = moment(startDate).subtract(diff, 'days').startOf('day').utc();
      const prevEnd = moment(endDate).subtract(1, 'day').endOf('day').utc();
      // TODO ORG Filter
      getPrevRangeData({
        variables: {
          orgId,
          startDate: prevStart,
          endDate: prevEnd,
          advertiserIds: !isEmpty(advertiserIds) ? advertiserIds : undefined,
        },
      });
    }
  }, [advertiserIds, endDate, getPrevRangeData, org, orgId, startDate]);

  useEffect(() => {
    refetch();
  }, [productOn, refetch]);

  return (
    <RollUpPaidSearchController
      {...props}
      org={org}
      refetch={refetch}
      data={data}
      loading={loading}
      prevRangeData={prevRangeData}
      loadingPrevRangeData={loadingPrevRangeData}
      refetchPrevRangeData={refetchPrevRangeData}
    >
      {children}
    </RollUpPaidSearchController>
  );
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withRouter(withApollo(RollUpPaidSearchDataLoader)));
